import React from "react";
import ConfirmModal from "components/common/modals/confirmModal/ConfirmModal";

const ApproveDeclineConfirmDialog = ({ open, status, onConfirm, onCancel }) => {
  const isApproving = status === "approved";

  return (
    <ConfirmModal
      show={open}
      title={isApproving ? "Approve Request" : "Decline Request"}
      confirmText={isApproving ? "Approve" : "Decline"}
      confirmButtonProps={{ color: isApproving ? "secondary" : "error" }}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      {isApproving
        ? "Are you sure you want to approve this request?"
        : "Are you sure you want to decline this request?"}
    </ConfirmModal>
  );
};

export default ApproveDeclineConfirmDialog;
